import '../login.css';
const NoPage = () => {
    return (

    <div className="wrapper" style={{ backgroundColor: '#191717' }}>
        <div className="oxy-video-container" style={{ overflow: 'hidden' }}>
            <video
                autoPlay
                loop
                playsInline
                muted
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    minWidth: '100%',
                    minHeight: '100%',
                    width: 'auto',
                    height: 'auto',
                    zIndex:1,
                    transform: 'translate(-50%, -50%)',
                }}
            >
                <source src="https://staging.socialmarketanalytics.com/videos/banner_ca.mp4" />
            </video>

            <div
                className="oxy-video-overlay"
                style={{
                    position: 'fixed', // Cover the entire viewport
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.53)', // Semi-transparent black
                    zIndex: 1, // Ensure it is above the video
                }}
            ></div>
        </div>

        <header
            id="header"
            style={{
                position: 'relative',
                zIndex: 2, // Ensure it's above the video and overlay
            }}
        >
            <div className="container">
                <div className="logo">
                    <a href="https://www.contextanalytics-ai.com/">
                        <img
                            src="https://staging.socialmarketanalytics.com/images/logo_ca.svg"
                            alt="logo"
                        />
                    </a>
                </div>
            </div>
        </header>


        <div className="maincontainer">
            <main id="dashboard-login">
                {/* Dashboard Heading outside the box */}
                <h1 className="login-box-heading">Dashboard</h1>

                <div className="login-box">
                    <form method="post" action="/login">
                        <div className="form-element">
                            <label>Email address</label>
                            <input type="email" id="email" name="email" required value="" />
                        </div>
                        <div className="form-element">
                            <label>Password</label>
                            <input type="password" id="password" name="password" required value="" />
                        </div>
                        <div
                            className="first_form form_element form_fullwidth av-last-visible-form-element"
                            id="element_avia_3_1"
                            style={{
                                display: 'flex', // Use flexbox to align items
                                alignItems: 'center', // Vertically center items
                                justifyContent: 'space-between',
                                marginBottom:'20px',// Push items to the edges
                            }}
                        >
                            <div className="checkbox-holder" style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                    name="stay_logged_in"
                                    className="input_checkbox"
                                    type="checkbox"
                                    id="stay_logged_in"
                                    value="on"
                                    style={{ marginRight: '5px' }} // Add space between checkbox and label
                                />
                                <label className="input_checkbox_label" htmlFor="stay_logged_in">
                                    Stay logged in
                                </label>
                            </div>

                            <a
                                style={{
                                    marginLeft: 'auto',
                                    textDecoration: 'none',
                                    color: '#2b97f0',
                                    fontSize: '14px', // Adjust font size for alignment
                                }}
                                href="/forgot_password"
                            >
                                Forgot my password
                            </a>
                        </div>
                        <div className="form_element flex-column">
                            <button className="button Login-btn" id="login">
                                Login
                            </button>
                        </div>
                    </form>
                </div>
            </main>
        </div>

    </div>

    )
};
export default NoPage;